import css from './Individual.module.scss';
import Myself from '../../assets/img/notary_photo_min.jpg'
import React from 'react';
import Container from 'components/Container/Container';

const Individual = () => {
  return (
      <section className={css.background} id="individual">
          <Container >
              <div className={css.container}>
              <img className={css.img} src={Myself} alt="" />
      <div className={css.div}>
        <h2 className={css.title}>Нотаріус</h2>
        <p className={css.text}>
          Поради нотаріуса – це корисні і обґрунтовні рекомендації фахівців, як
          юридично правильно вчинити в тій чи іншій життєвій ситуації, щоб
          захистити свої права, інтереси, щоб зберегти гроші, майно, бізнес.
          Дуже рекомендуємо проконсультуватися у нотаріуса перш, ніж здійснювати
          будь-яку нотаріальну дію. Будь то питання придбання нерухомості, свідоцтва
          про право про спадщину, покупка автомобіля або нюанси видачі
          довіреності – в цих та багатьох інших справах саме звернення до
          нотаріуса стане гарантією захисту прав, інтересів, власності. Навіть
          такі прості питання, як згоду на виїзд дитини за кордон або видача
          довіреності на продаж автомобіля, можуть таїти в собі безліч нюансів.
          Відповідно до закону, нотаріус несе повну майнову відповідальність за
          свою роботу: це означає, що нотаріус повністю відшкодовує своєму
          клієнтові збитки, які виникли в результаті провини або помилки
          нотаріуса. Якщо Ви живете в Ужгороді Вам буде корисно дізнатися про
          нашу нотаріальну контору. Професіоналізм, відмінний сервіс та увагу до
          деталей – головні наші переваги. Індивідуальний підхід до кожного
          клієнта є гарантом результату!
        </p>
        <a href='#servises' className={css.link}>Послуги</a>
                  </div>
                  </div>
              </Container>
  
    </section>
  );
};

export default Individual;
